/////////////////////////////////////////////////////
// Add your custom code here.
// This file and any changes you make to it are preserved every time the app is generated.
/////////////////////////////////////////////////////
import { Inject, Injector, Component } from '@angular/core';
import { AppLayoutViewBaseComponent } from './app-layout.view.base.component';
import { Router } from '@angular/router';

@Component({
    selector: 'kb-app-layout',
    templateUrl: './app-layout.view.component.extended.html',
    styleUrls: ['./app-layout.view.component.css'],
})
export class AppLayoutViewComponent extends AppLayoutViewBaseComponent {

    private  $router: Router;

    constructor(@Inject(Injector) injector: Injector) {
        super(injector);
        this.$router = injector.get(Router);
    }
    
    // Fired when component is initialized and input properties are set
    public onInit(): void {}
    // Fired when component's views and child views are initialized
    public onShow(): void {}
    // Fired just before Angular destroys the component. Unsubscribe Observables and detach event handlers to avoid memory leaks
    public onHide(): void {}
    //Initial Page link
    public initialPage(): void {
        this.$router.navigate(['/']);        
      }

}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/application/app-layout/app-layout.view.component.ts